export default __webpack_public_path__ + "static/media/AkshayKK.3cfbdca3.png";